const navBarField = [
  {
    icon: require('@/assets/new/icon_programs.svg?external'),
    text: 'programs',
    key: 'Programs',
    routeName: 'Programs',
    show: 'true',
  },
  {
    icon: require('@/assets/new/icon_dashboard.svg?external'),
    text: 'dealer-list',
    key: 'Dealer',
    routeName: 'Dealer-List',
    show: 'true',
  },
  {
    icon: require('@/assets/new/icon_dashboard2.svg?external'),
    text: 'dashboard',
    key: 'Dashboard',
    routeName: 'Dashboard',
    show: 'true',
  },
  {
    icon: require('@/assets/new/icon_pillars.svg?external'),
    text: 'pillars',
    key: 'Pillars',
    routeName: 'Pillars',
    show: 'true',
  },
  {
    icon: require('@/assets/new/icon_archive.svg?external'),
    text: 'archive',
    key: 'Archive',
    routeName: 'Archive',
    show: 'true',
  },
];

export default () => navBarField;
